"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableFormat = void 0;
exports.parseTableFormat = parseTableFormat;
exports.lastUrlPart = lastUrlPart;
exports.tableFormatForSpecies = tableFormatForSpecies;
const sparql_1 = require("./sparql");
const BinTable_1 = require("./BinTable");
function parseTableFormat(sparqlResult) {
    const bindings = sparqlResult.results.bindings;
    const columnsInfo = bindings.map(binding => {
        return {
            name: binding.colName.value,
            label: binding.valueType.value,
            unit: binding.unit?.value ?? "?",
            type: mapDataTypes(binding.valFormat.value),
            valueFormat: binding.valFormat.value,
            isRegex: binding.isRegex?.value.toLowerCase() === 'true',
            flagCol: binding.flagColName?.value
        };
    });
    if (bindings.length > 0) {
        const formatUrl = bindings[0].objFormat.value;
        const goodFlags = bindings[0].goodFlags;
        const flagGoodness = goodFlags === undefined
            ? undefined
            : goodFlags.value.length == 0 ? undefined : f => goodFlags.value.includes(f);
        return Promise.resolve(new TableFormat(columnsInfo, formatUrl, flagGoodness));
    }
    else
        return Promise.reject(new Error("SPARQL query about column metadata returned no results"));
}
function lastUrlPart(url) {
    const last = url.split("/").pop();
    if (last === undefined)
        throw new Error("Not a valid URL: " + url);
    return last;
}
function mapDataTypes(valueFormatUrl) {
    switch (lastUrlPart(valueFormatUrl)) {
        case "float32":
            return "FLOAT";
        case "float64":
            return "DOUBLE";
        case "bmpChar":
            return "CHAR";
        case "etcDate":
            return "INT";
        case "iso8601date":
            return "INT";
        case "iso8601month":
            return "INT";
        case "iso8601timeOfDay":
            return "INT";
        case "iso8601dateTime":
            return "DOUBLE";
        case "isoLikeLocalDateTime":
            return "DOUBLE";
        case "etcLocalDateTime":
            return "DOUBLE";
        case "boolean":
            return "BYTE";
        case "int32":
            return "INT";
        case "string":
            return "STRING";
        default:
            throw new Error("Unsupported value format: " + valueFormatUrl);
    }
}
class TableFormat {
    constructor(_columnsInfo, formatUrl, flagGoodness) {
        this._columnsInfo = _columnsInfo;
        this.flagGoodness = flagGoodness;
        this._subFolder = lastUrlPart(formatUrl);
        this.qflagLookup = this._columnsInfo.reduce((acc, colInfo, idx, _) => {
            if (colInfo.flagCol != undefined) {
                const flagPos = this._columnsInfo.findIndex(cInfo => cInfo.name === colInfo.flagCol);
                if (flagPos >= 0)
                    acc[idx] = flagPos;
            }
            return acc;
        }, {});
    }
    getColumnIndex(colName) {
        return this._columnsInfo.findIndex(colInfo => colName === colInfo.name);
    }
    get columns() {
        return this._columnsInfo;
    }
    getRequest(id, nRows, columnIndices, slice) {
        const cols = this._columnsInfo.map(colInfo => colInfo.type);
        const requestedCols = columnIndices || Array.from(cols, (_, i) => i);
        const missingFlagCols = requestedCols.reduce((acc, curr) => {
            const flagColNum = this.qflagLookup[curr];
            if (flagColNum != undefined && !requestedCols.includes(flagColNum))
                acc.push(flagColNum);
            return acc;
        }, []);
        return new BinTable_1.TableRequest(lastUrlPart(id), {
            columns: cols,
            qflagLookup: this.qflagLookup,
            size: nRows
        }, requestedCols.concat(missingFlagCols), this._subFolder, slice);
    }
    withColumnNames(columnNames) {
        const columnsInfo = columnNames.slice().sort().map(cn => {
            return Object.assign({}, this._columnsInfo.find(c => {
                if (c.isRegex) {
                    const re = new RegExp(c.name);
                    return re.test(cn);
                }
                else {
                    return c.name == cn;
                }
            }), { name: cn });
        });
        return new TableFormat(columnsInfo, this._subFolder, this.flagGoodness);
    }
}
exports.TableFormat = TableFormat;
function tableFormatForSpecies(objSpeciesUri, config, acceptCache) {
    const query = objectSchemaQuery(objSpeciesUri, config);
    return (0, sparql_1.sparql)(query, config.sparqlEndpoint, acceptCache).then(parseTableFormat);
}
function objectSchemaQuery(speciesUri, config) {
    const query = `prefix cpmeta: <${config.cpmetaOntoUri}>
SELECT distinct ?objFormat ?goodFlags ?colName ?valueType ?valFormat ?unit ?qKind ?colTip ?isRegex ?flagColName
WHERE {
	{
		select ?objFormat (group_concat(?goodFlag; separator=";") as ?goodFlags) where{
			<${speciesUri}> cpmeta:hasFormat ?objFormat .
			optional {?objFormat cpmeta:hasGoodFlagValue ?goodFlag}
		}
		group by ?objFormat
	}
	<${speciesUri}> cpmeta:containsDataset ?dset .
	?dset cpmeta:hasColumn ?column .
	?column cpmeta:hasColumnTitle ?colName ;
		cpmeta:hasValueFormat ?valFormat ;
		cpmeta:hasValueType ?valType .
	optional{?column cpmeta:isRegexColumn ?isRegex}
	optional{
		?flagCol cpmeta:isQualityFlagFor ?column ; cpmeta:hasColumnTitle ?flagColName .
		?dset cpmeta:hasColumn ?flagCol .
	}
	?valType rdfs:label ?valueType .
	optional{?valType rdfs:comment ?colTip }
	optional{
		?valType cpmeta:hasUnit ?unit .
		?valType cpmeta:hasQuantityKind/rdfs:label ?qKind .
	}
} order by ?colName`;
    return { text: query };
}
